import type { languages } from 'monaco-editor';

export const languageConfiguration: languages.LanguageConfiguration = {
  wordPattern: /(?:\\.|[^\s\\():<>"*{}])+/g,
  brackets: [
    ['(', ')'],
    ['{', '}'],
  ],
  autoClosingPairs: [
    { open: '(', close: ')' },
    { open: '{', close: '}' },
    { open: '"', close: '"' },
  ],
  surroundingPairs: [
    { open: '(', close: ')' },
    { open: '{', close: '}' },
    { open: '"', close: '"' },
  ],
};
